import React from 'react'

function TechSDKLIGZ() {
  return (
    <embed src="\pdfs\E2.4.2.1_DK-LIG-Z_Chilled_beam_05.2003_kr.pdf" width="100%" height="2100px" />
  )
}

export default TechSDKLIGZ